import { Decryption, Encryption } from "./Crypto";

const secureStorage = (storageType) => ({
  getItem: (key) =>
    new Promise((resolve) => {
      const encryptedValue = storageType?.getItem(key);
      if (!encryptedValue) return resolve(null);

      try {
        resolve(Decryption(encryptedValue));
      } catch (error) {
        console.error("Decryption error:", error);
        resolve(null);
      }
    }),

  setItem: (key, value) =>
    new Promise((resolve) => {
      storageType?.setItem(key, Encryption(value));
      resolve();
    }),

  removeItem: (key) =>
    new Promise((resolve) => {
      storageType?.removeItem(key);
      resolve();
    }),

  clear: () =>
    new Promise((resolve) => {
      storageType?.clear();
      resolve();
    }),
});

// Export secure storage instances
export const secureLocalStorage = secureStorage(localStorage);
export const secureSessionStorage = secureStorage(sessionStorage);
